/**
 * Trip ids belong to legs (`legs` + `trips`), never to `orders.eapi_trip_id`.
 *
 * For a single-leg order the order's external trip IS leg 1's active trip.
 * The deprecated parent column can go stale (AOP-WENP-03315: regenerate
 * swapped leg 1's trip, the parent column kept the abandoned id, and the
 * next edit PATCHed the abandoned trip). This resolver answers "which trip
 * does this single-leg order have?" from the leg rows only.
 */
export interface LegTripRef {
  leg_id: string;
  leg_sequence: number;
  eapi_trip_id: string;
}

/**
 * Returns leg 1's active trip id when the order has exactly one leg; `null`
 * when it has none. Returns `undefined` for multi-leg orders, meaning
 * "not a single-leg question — callers keep their per-leg handling".
 */
export function resolveSingleLegTripId(
  legCount: number,
  activeLegTrips: LegTripRef[],
): string | null | undefined {
  if (legCount !== 1) return legCount > 1 ? undefined : null;
  return activeLegTrips.find((t) => t.leg_sequence === 1)?.eapi_trip_id ?? null;
}
